

class AccordionItemHTMLElement extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();
    }

    connectedCallback() {
        const toggler = this.querySelector( 'button' );
        toggler?.addEventListener( 'click', this.toggle.bind( this ) );
    }

    disconnectedCallback() {

    }

    toggle() {
        const siblings = this.closest( 'section, .section' )?.querySelectorAll( 'accordion-item' );
        siblings?.forEach( sibling => {
            if ( sibling !== this ) sibling.removeAttribute( 'open' );
        } );
        this.toggleAttribute( 'open' );
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback( name, oldVal, newVal ) {
        switch ( name ) {
            case 'open':
                break;
        }
    }
}

customElements.define( 'accordion-item', AccordionItemHTMLElement );